import { NgModule } from '@angular/core';
import { SharedModule, addNavMenuSection, registerBulkAction } from '@vendure/admin-ui/core';
import { deleteContactBulkAction } from './components/all-contact-us-list/bulk-actions';

@NgModule({
    imports: [SharedModule],
    providers: [
        registerBulkAction(deleteContactBulkAction),
        addNavMenuSection(
            {
                id: 'contact-nav',
                label: 'Contacts',
                items: [
                    {
                        id: 'contact',
                        label: 'Contacts',
                        routerLink: ['/extensions/contact'],
                        // Icon can be any of https://clarity.design/icons
                        icon: 'folder-open',
                    },
                ],
                // requiresPermission: 'SuperAdmin',
            },
            // Add this section before the "settings" section
            'settings',
        ),
    ],
})
export class ContactExtensionModule {}
